module.exports = __webpack_public_path__ + "img/tanchuan.bb3c3cb7.svg";